import { Component,ViewChild } from '@angular/core';
import {
    ModalController, ViewController, NavParams, Slides, PopoverController, NavController,
    AlertController
} from 'ionic-angular';
import { PopoverPage } from '../about-popover/about-popover';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UserData} from "../../providers/user-data";
import {JobSelectForm} from "../utils/job-select/job-select";
import {MissionsListPage} from "../missions/missions-list/missions-list";

@Component({
    selector: 'page-switch',
    templateUrl: 'switch.html'
})
export class SwitchPage {
    @ViewChild('slides') slides: Slides;

    skippable:any = true;
    savable:boolean = false;
    jobOpened:boolean = false;
    form : FormGroup;
    formData:any = true;

    sessionRef: any;
    userRef: any;
    submitAttempt:boolean=false;

    constructor(
        public popoverCtrl: PopoverController,
        public navCtrl: NavController,
        public navParams:NavParams,
        public formBuilder: FormBuilder,
        public userData: UserData,
        public alertCtrl:AlertController,
        public modalCtrl:ModalController
    ) {
        if(navParams.data.skippable != undefined)
        this.skippable = navParams.data.skippable;

        this.form = this.formBuilder.group({
            firstname: [null, Validators.required],
            lastname: [null, Validators.required],
            phone: [null, Validators.required],
            company: [null, Validators.required],
            zipcode: [null, Validators.required],
            poste: [null, Validators.required]
        });
        this.formData = {
            firstname: "",
            lastname: "",
            //email: "",
            phone: "",
            company: "",
            zipcode: "",
            poste: "",
            contact_name: "",
            contact: "",
            anonymous:false
        };
    }
    ionViewDidLoad() {
        this.getUserInfos();
    }
    ionViewWillUnload() {
        this.sessionRef.unsubscribe();
        this.userRef.unsubscribe();
    }
    getUserInfos() {
        var that = this;
        if(!that.sessionRef || that.sessionRef.closed) {
            that.sessionRef = that.userData.userSession().subscribe(session => {
                if (session !== null) {
                    that.userRef = that.userData.load().subscribe(user => {
                        let civility = that.userData.get('civility');

                        if (civility && civility.prenom) {
                            that.formData.firstname = civility.prenom;
                        }
                        if(civility && civility.nom) {
                            that.formData.lastname = civility.nom;
                        }
                        /*if(civility && civility.email)
                        {
                            that.formData.email = civility.email;
                        }*/
                        if(civility && civility.phone)
                        {
                            that.formData.phone = civility.phone;
                        }
                    });
                }
            });
        }

    }
    chooseJob()
    {
        var that = this;
        if(!this.jobOpened)
        {
            let jobSelectModal = this.modalCtrl.create(JobSelectForm, { mode: "certificates" });
            jobSelectModal.onDidDismiss(data => {
                this.jobOpened = false;
                if(data.success)
                {
                    this.formData.poste = data.name;
                }
                else
                {

                }
            });
            this.jobOpened = true;
            jobSelectModal.present();
        }

    }
    onSlideChangeStart(event: Event) {
        let currentIndex = this.slides.getActiveIndex();
        if(currentIndex==2)
        {
            var that=this;
            setTimeout(function(){that.savable=true},150)
            //this.savable=true;
            /*this.slides.pager=false;
            this.slides.centeredSlides=false;
            this.slides.update();
            this.slides.resize();*/
            this.slides.lockSwipeToPrev(true);
            this.slides.lockSwipeToNext(true);
        }
    }
    presentPopover(event: Event) {
        let popover = this.popoverCtrl.create(PopoverPage);
        popover.present({ ev: event });
    }
    nextSlide(i)
    {
        this.slides.slideTo(i,500);
    }
    skip(event)
    {
        this.navCtrl.setRoot(MissionsListPage);
    }
    saveSwitch()
    {
        //this.slides.resize();
        this.submitAttempt=true;
        /* Todo : check controls */
        if(this.form.valid) {
            var that = this;
            that.userData.localPush("",'switchMessages',that.formData);
            that.userData.update("civility",'phone',that.formData.phone);
            that.userData.update("civility",'nom',that.formData.lastname);
            that.userData.update("civility",'prenom',that.formData.firstname);
            that.userData.update("address",'cp',that.formData.zipcode);

            let prompt = that.alertCtrl.create({
                enableBackdropDismiss:false,
                title: 'Merci !',
                message: "Nous avons enregistré votre demande, nous reviendrons vers vous sous 24h.",
                buttons: [
                    {
                        text: 'Ok',
                        handler: data => {
                            that.navCtrl.setRoot(MissionsListPage);
                        }
                    }
                ]
            });
            prompt.present();

        }
        else
        {
            //console.log(this.form.value);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/switch/switch.ts